import logoIcon from '@assets/logomark.svg'

export default function LogoIcon({ ...rest }) {
	return <img src={logoIcon} alt="Artemis Logo" {...rest} />
}
